import { gql } from 'graphql-tag';
import { INTERNAL_LINK_FRAGMENT } from './internalLink.fragment';

export const INTERNAL_LINKS_FRAGMENT = gql`
    ${INTERNAL_LINK_FRAGMENT}

    fragment INTERNAL_LINKS_FRAGMENT on InternalLinks {
        category
        geo
        propertyType
        section
        transactionType
        rows {
            links {
                ...INTERNAL_LINK_FRAGMENT
            }
        }
        links {
            ...INTERNAL_LINK_FRAGMENT
        }
    }
`;
